<template>
  <div class="card" :class="{ 'card-empty': noData }">
    <h2>Watertemperatuur</h2>
    <template v-if="!noData">
      <div class="temperature">
        <img :src="waterTemperatureIcon" alt="" />
      </div>
      <p>
        <b>{{ waterTemperature }} °C</b>
      </p>
    </template>
    <EmptyCardBody v-else />
  </div>
</template>
<script>
import { defineComponent } from "@vue/composition-api";
import EmptyCardBody from "@/components/EmptyCardBody.vue";

export default defineComponent({
  name: "WaterTemperatureCard",
  props: {
    waterTemperatureIcon: String,
    waterTemperature: Number,
    noData: Boolean,
  },
  components: {
    EmptyCardBody,
  },
  setup() {},
});
</script>
